// Discography data for Mastafive
// Each entry: { year, artist, title, note? }
// Spotify search URL: https://open.spotify.com/search/<encoded_query>

export const albumsAndEPs = [
  { year: "1994", artist: "Gerstein", title: "St. Anthony's Fire" },
  { year: "1997", artist: "Rawl MC", title: "La Notte E.P." },
  { year: "1998", artist: "Gatekeepaz feat. Maory B.", title: "Custodi del segreto", note: "Disponibile anche in versione Remastered digitale" },
  { year: "1999", artist: "Gatekeepaz", title: "Dietro il cancello", note: "Disponibile anche in versione Remastered digitale" },
  { year: "2001", artist: "Rawl MC", title: "Il mondo" },
  { year: "2002", artist: "Jacky Blu", title: "Dolce Stile", note: "Produzione della traccia Dolce come il sale e Rap in \"Deve Andare Così\"" },
  { year: "2002", artist: "Ragazzi'n Gamba", title: "Gioco da Soul" },
  { year: "2002", artist: "MC Giaime", title: "Incompatibile 1999 - 2002", note: "Partecipazione con i Gatekeepaz alla traccia 02" },
  { year: "2003", artist: "Jhanasky (Elektromasta)", title: "The Fat Brother of Kerlin Krenzen" },
  { year: "2003", artist: "Underground People", title: "Volume 1" },
  { year: "2004", artist: "Blood & Soul", title: "L'Unica Risposta", note: "Produzione di 3 tracce" },
  { year: "2004", artist: "Da Giantz", title: "Da Giantz" },
  { year: "2004", artist: "Simplytre", title: "Semplice... mente", note: "Produzione della traccia Pura connessione" },
  { year: "2004", artist: "Dawlaz", title: "ijustwant", note: "Produzione della traccia Mona dawlaz" },
  { year: "2004", artist: "Mastafive", title: "Pace, amore e vaffanculo", note: "Raccolta d'archivio 1994-2004" },
  { year: "2004", artist: "Malva & DJ Rex", title: "Make Noize", note: "Produzione di Voglio un suono e Certi giorni" },
  { year: "2005", artist: "Lunatici", title: "Primo Quarto" },
  { year: "2005", artist: "DJ Kamo", title: "On The Real Vol.2" },
  { year: "2005", artist: "OneMic", title: "Sotto la cintura", note: "Produzione del brano Nel cuore della terra" },
  { year: "2005", artist: "Mastafive", title: "Dammi un Beat", note: "Riedito ufficialmente in versione Remastered digitale nel 2020" },
  { year: "2006", artist: "Clementino", title: "Napoli Manicomio" },
  { year: "2006", artist: "Jhanasky", title: "End Or Fine" },
  { year: "2007", artist: "Pula+", title: "Mia Fobia" },
  { year: "2007", artist: "Raige", title: "Hip Hope" },
  { year: "2007", artist: "Rayden", title: "C.A.L.M.A." },
  { year: "2007", artist: "Strike The Head", title: "Prima di Dormire" },
  { year: "2007", artist: "Canebullo", title: "Mani Sporche" },
  { year: "2007", artist: "Rew e Shade", title: "Super Eroe Offresi" },
  { year: "2020", artist: "Mastafive", title: "Beats For Freestyle, Vol. 1", note: "Raccolta di strumentali" },
  { year: "2020", artist: "Mastafive", title: "C.G.P.S.F.S.T.D.A.C.", note: "Compilation di tracce dove Mastafive fa il Rap, distribuita da B.M. Records" },
  {
    year: "2024",
    artist: "Mastafive",
    title: "Euforia Collabo",
    note: "Album/compilation di 11 tracce interamente curato da Mastafive. Include: Istintro (con Alfre D'), Me And The Mic (con Lefty, Dema, Sfera & DJ Kamo), Mi Pare Remix (con Principe e Libo), Andare Via (con Funk Shui Project e Kiave), Il Testimone - Problem 9 (con Papilla Bronx e Norman H), Formiche RMX (con Rawl Mc e Psyko Killa)"
  }
];

export const singlesAndTracks = [
  { year: "1997", artist: "Gatekeepaz", title: "7 WD", note: "Mixtape Lo capisci l'italiano vol.1 di DJ Double S" },
  { year: "1997", artist: "Maury B.", title: "Dimensioni Mistiche (Natural Mistic Remix)" },
  { year: "1998", artist: "Gatekeepaz", title: "Tecniche Perfette", note: "In Sampla'98" },
  { year: "1998", artist: "Back Wood Kids", title: "51a Chiusura", note: "In Sampla'98" },
  { year: "1998", artist: "Rawl MC feat. Mem-H-Ori", title: "Pensieri", note: "In Sampla'98" },
  { year: "2000", artist: "Gatekeepaz feat. DJ Double S", title: "Gate Metal Jacket", note: "Singolo ufficiale, anche in digitale" },
  { year: "2000", artist: "Gatekeepaz Crew", title: "Sedie in Circolo", note: "In Homies and Money" },
  { year: "2001", artist: "Mastafive feat. MX", title: "Fuga e Fiesta", note: "Singolo ufficiale, anche in digitale" },
  { year: "2001", artist: "Mastafive", title: "Mastafive lo fa", note: "In Hip Hop and Stop" },
  { year: "2002", artist: "Mastafive & BiggaGià2", title: "Messo come sei", note: "In Da Bombz" },
  { year: "2002", artist: "DJ Lil Cut & DJ Walterix", title: "Dinamyte soul Men", note: "In Diesel U Music" },
  { year: "2003", artist: "Mastafive", title: "Fanculo Nicola", note: "In Nucleo Compatto vol.2" },
  { year: "2004", artist: "Deal The Dihlyo feat. DJ Double S", title: "One Two", note: "In DB Magazine Sampler .05" },
  { year: "2004", artist: "Mastafive", title: "No Penzo", note: "In Eblood R.Evolutionary Hits .02" },
  { year: "2004", artist: "Mastafive & TRZTA", title: "Tecniche Perfette 2004" },
  { year: "2005", artist: "I.R.A.", title: "L'Infame" },
  { year: "2005", artist: "Gatekeyz feat. Blade & Faktor", title: "Prospettive Atto Primo", note: "In Eblood R.Evolutionary Hits .03" },
  { year: "2006", artist: "Gatekeyz", title: "Stai Tranquillo" },
  { year: "2006", artist: "Da Giantz", title: "Palla al piede", note: "In HipHop Solidale" },
  { year: "2006", artist: "Ragazzi 'n Gamba", title: "Quando Vieni", note: "In DJ Koma - Una Mole di MC's" },
  { year: "2007", artist: "TheNextOne", title: "The Age Of Acquarius", note: "Mixtape" },
  { year: "2007", artist: "Pula+", title: "Cosa vuoi da me", note: "In Monkey Bizness" },
  { year: "2019", artist: "Mastafive", title: "Bad Boy" },
  { year: "2024", artist: "Mastafive, Sesto Carnera, Blo/B, De Angelo Parpaglione", title: "Galassia" },
  { year: "2025", artist: "Mastafive", title: "Genova è / Main e Calvi" },
  { year: "2025", artist: "Mastafive feat. Dikson", title: "Classic Skillz (Version 91)" },
  { year: "2025", artist: "Mastafive & Jhanaskys orchestra", title: "now for ever", note: "Progetto per la neonata IIATJ label" },
  { year: "2025", artist: "Mastafive feat. 3DC", title: "Hustler RMX" },
  { year: "2025", artist: "Mastafive", title: "MAKUTO" },
  { year: "2025", artist: "Mastafive + Gera quello Vero", title: "La provincia della provincia" },
  { year: "2025", artist: "Mastafive & Royal KS", title: "Aspettando Quattalari" },
  { year: "2025", artist: "Mastafive", title: "Porkeria Tango y Cumbita" },
  { year: "2025", artist: "Mastafive & Assalti Frontali", title: "Raperendum (8-9 giugno dagli un pugno)" },
  { year: "2025", artist: "Mastafive feat. De Angelo Parpaglione & Numb", title: "Fuori di me" },
  { year: "2025", artist: "Mastafive", title: "Insomnia Sunset", note: "E.P. Strumentale" },
  { year: "2026", artist: "Mastafive, Gizmo & Vagasbronzo", title: "Zoticone" },
  { year: "2026", artist: "Mastafive & Stylo aka Space", title: "Sempre comunque" },
  { year: "2026", artist: "Mastafive, Fato, Sguardo", title: "Un Giro con Noi" }
];

export const collaborations = [
  { artist: "Must Oslo feat. Mastafive", title: "Cuore Blu" },
  { artist: "Promo L'Inverso feat. Principe, Maury B & Mastafive", title: "Rap Fenomeno" }
];

// Helper to generate Spotify web-player search URL for a track
export function spotifySearchUrl(entry) {
  const cleanArtist = (entry.artist || "")
    .replace(/\bfeat\.?\b/gi, "")
    .replace(/\bfeaturing\b/gi, "")
    .replace(/\s+/g, " ")
    .trim();
  const cleanTitle = (entry.title || "")
    .replace(/\(.*?\)/g, "")
    .replace(/\s+/g, " ")
    .trim();
  const q = `${cleanArtist} ${cleanTitle}`.trim();
  return `https://open.spotify.com/search/${encodeURIComponent(q)}`;
}
